"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _eventListener = _interopRequireDefault(require("@use-it/event-listener"));

var _createSynchronizedState = _interopRequireDefault(require("./createSynchronizedState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var usePersistedState = function usePersistedState(initialState, key, _a) {
  var get = _a.get,
      set = _a.set;
  var synchronizedState = (0, _react.useRef)(null);

  var _b = (0, _react.useState)(function () {
    return get(key, initialState);
  }),
      state = _b[0],
      setState = _b[1]; // This updates state whenever "storage" events are triggered for the specified key.


  (0, _eventListener["default"])('storage', function (_a) {
    var k = _a.key,
        newValue = _a.newValue;

    if (k === key) {
      var newState = JSON.parse(newValue);

      if (state !== newState) {
        setState(newState);
      }
    }
  }); // Setup and cleanup

  (0, _react.useEffect)(function () {
    synchronizedState.current = (0, _createSynchronizedState["default"])(key, setState, initialState);
    return function () {
      synchronizedState.current.unregister();
    };
  }, []);
  (0, _react.useEffect)(function () {
    set(key, state);
    synchronizedState.current.emit(state);
  }, [state]);
  return [state, setState];
};

var _default = usePersistedState;
exports["default"] = _default;